import { Icon, Menu } from 'semantic-ui-react';
import React from 'react';

export default function CloseIcon({ handleClose }) {
  return (
    <>
      <Menu secondary className="close-component">
        <Menu.Item className="ui right floated">
          <Icon name="close" className="close-icon light" size="large" onClick={handleClose} />
        </Menu.Item>
      </Menu>
    </>
  );
}
